import { CurrencyOptions } from '../../../../contexts/CurrencyContext';
import { getDefaultFilterOptions } from '../default';

const COLLECTION = {
  type: 'checkbox',
  title: 'Collection',
  labels: ['Survivors Gen #1', 'Survivors Gen #2'],
};

const CHAIN = {
  type: 'checkbox',
  title: 'Chain',
  labels: ['Fantom'],
};

export const getFantomSurvivorFilterOptions = (
  currencyOptions: CurrencyOptions,
) => {
  return [...getDefaultFilterOptions(currencyOptions), CHAIN, COLLECTION];
};
